import * as React from "react";
import {confirmDialog} from 'primereact/confirmdialog';

export function notify(message:string, accept?: any, headerTitle?: string) {
    confirmDialog({
        message,
        header: headerTitle ?? 'Внимание!',
        accept,
        reject: null,
        acceptLabel: 'Ок',
        rejectLabel: ' '
    });
}
